import React, {useCallback} from 'react';
import styled, {css} from 'styled-components';
import {useIntl} from 'react-intl';
import {Icon, tokensForThemeProvider} from '@forecast-it/design-system';
import {D} from '../ai-chat/design-tokens';
import AgentDropdown from './AgentDropdown';

const {font} = tokensForThemeProvider.sky.sys;

const bodyFont = css`
	${font.body['1']}
`;

const MenuRow = styled.button`
	${bodyFont}
	display: flex;
	align-items: center;
	width: 100%;
	height: 44px;
	padding: 0 16px;
	gap: 0;
	border: none;
	background: transparent;
	cursor: pointer;
	text-align: left;
	color: ${D.v2.textPrimary};

	&:hover {
		background: ${D.v2.surfaceHover};
	}
`;

const MenuRowIcon = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	flex-shrink: 0;
	color: ${D.v2.textPrimary};
`;

const DROPDOWN_STYLE: React.CSSProperties = {
	top: 52,
	right: 24,
	width: 299,
	borderColor: D.inputBorder,
};

type KebabMenuProps = {
	onClearChat: () => void;
	onRegenerateLastReply: () => void;
	canRegenerate: boolean;
	onClose: () => void;
	excludeRef?: React.RefObject<HTMLElement>;
};

const KebabMenu = ({onClearChat, onRegenerateLastReply, canRegenerate, onClose, excludeRef}: KebabMenuProps): JSX.Element => {
	const {formatMessage} = useIntl();

	const handleClearChat = useCallback(() => {
		onClearChat();
		onClose();
	}, [onClearChat, onClose]);

	const handleRegenerate = useCallback(() => {
		onRegenerateLastReply();
		onClose();
	}, [onRegenerateLastReply, onClose]);

	return (
		<AgentDropdown onClose={onClose} excludeRef={excludeRef} style={DROPDOWN_STYLE}>
			<MenuRow type="button" onClick={handleClearChat}>
				<MenuRowIcon>
					<Icon icon="close" size="m" />
				</MenuRowIcon>
				{formatMessage({id: 'nova.header.clear_chat'})}
			</MenuRow>
			{canRegenerate && (
				<MenuRow type="button" onClick={handleRegenerate}>
					<MenuRowIcon>
						<Icon icon="reload" size="m" />
					</MenuRowIcon>
					{formatMessage({id: 'nova.header.regenerate_last_reply'})}
				</MenuRow>
			)}
		</AgentDropdown>
	);
};

export default KebabMenu;
